import { TypeActionLoading } from "../../loading/actionLoading";
import { epicContractInfoFactory } from "./epicContractInfoFactory";
export var epicContractInfoPlayerInfoReceived = epicContractInfoFactory(TypeActionLoading.Complete);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoPlayerInfoReceived.ts
// module id = 1991
// module chunks = 3